import { getSummary } from './Summary';
import { getCommentContexts } from './CommentContexts';
import { call } from 'redux-saga/effects';

export function* fetchCommentHistorySummary() {
  try {
    yield call(getSummary);
  } catch (error) {
    console.error(error);
  }
}

export function* fetchCommentHistoryData() {
  try {
    yield call(getCommentContexts);
  } catch (error) {
    console.error(error);
  }
}
